import type { BrowseMarket } from '@/api/cmApi'

/** CM market status/update vendor — bookmaker overlay ids use vendor `bookmaker`. */
export function marketVendor(m: BrowseMarket): string {
  if (m.vendor?.trim()) return m.vendor.trim()
  return m.vendorMarketId.includes('#bookmaker') ? 'bookmaker' : 'betfair'
}

export function isBookmakerMarket(m: BrowseMarket): boolean {
  return (
    marketVendor(m) === 'bookmaker' ||
    m.bookmakerCustom === true ||
    m.vendorMarketId.includes('#bookmaker')
  )
}

/** Lab scorecardCheck gate — numeric Betradar id alone is not enough on shark. */
export function isBetradarFromId(betradarId: string | null | undefined): boolean {
  return Boolean(String(betradarId ?? '').trim())
}

/** Lab manageMarketCM lists exchange + bookmaker overlay markets for one event. */
export function mergeBrowseMarkets(
  exchange: BrowseMarket[],
  bookmaker: BrowseMarket[],
): BrowseMarket[] {
  const seen = new Set<string>()
  const out: BrowseMarket[] = []
  for (const m of [...exchange, ...bookmaker]) {
    const key = `${marketVendor(m)}:${m.vendorMarketId}`
    if (seen.has(key)) continue
    seen.add(key)
    out.push(m)
  }
  return out
}
